export const qualificationMixin = {
  methods: {
    getQualificationMixin(qualificationCode) {
      switch (qualificationCode) {
        case 1:
          return {
            title: 'Not contacted',
            value: 'not_contacted',
            qualification: qualificationCode,
          };
        case 2:
          return {
            title: 'Contacted',
            value: 'contacted',
            qualification: qualificationCode,
          };
        case 3:
          return {
            title: 'Interviewing',
            value: 'interviewing',
            qualification: qualificationCode,
          };
        case 4:
          return {
            title: 'Submitted',
            value: 'submitted',
            qualification: qualificationCode,
          };
        case 5:
          return {
            title: 'No longer interested',
            value: 'no_longer_interested',
            qualification: qualificationCode,
          };
        case 6:
          return {
            title: 'Not in consideration',
            value: 'not_in_consideration',
            qualification: qualificationCode,
          };
        case 7:
          return {
            title: 'Responded',
            value: 'responded',
            qualification: qualificationCode,
          };
        case 8:
          return {
            title: 'Qualifying',
            value: 'qualifying',
            qualification: qualificationCode,
          };

        case 'not_contacted':
          return {
            title: 'Not contacted',
            value: 1,
            qualification: qualificationCode,
          };
        case 'contacted':
          return {
            title: 'Contacted',
            value: 'contacted',
            qualification: 2,
          };
        case 'interviewing':
          return {
            title: 'Interviewing',
            value: 'interviewing',
            qualification: 3,
          };
        case 'submitted':
          return {
            title: 'Submitted',
            value: 'submitted',
            qualification: 4,
          };
        case 'no_longer_interested':
          return {
            title: 'No longer interested',
            value: 'no_longer_interested',
            qualification: 5,
          };
        case 'not_in_consideration':
          return {
            title: 'Not in consideration',
            value: 'not_in_consideration',
            qualification: 6,
          };
        case 'responded':
          return {
            title: 'Responded',
            value: 'responded',
            qualification: 7,
          };
        case 'qualifying':
          return {
            title: 'Qualifying',
            value: 'qualifying',
            qualification: 8,
          };

        default:
          return {
            title: '',
            value: '',
            qualification: qualificationCode,
          };
      }
    },
    getQualificationColorClass(qualificationCode) {
      /*   public const QUALIFICATION_NOT_CONTACTED = 1;
    public const QUALIFICATION_CONTACTED = 2;
    public const QUALIFICATION_INTERVIEWING = 3;
    public const QUALIFICATION_SUBMITED = 4;
    public const QUALIFICATION_NO_LONGER_INTERESTED = 5;
    public const QUALIFICATION_NOT_IN_CONSIDERATION = 6; */

      let qualificationColorClass;

      switch (Number(qualificationCode)) {
        case 1:
          qualificationColorClass = 'qualification-color-not-submitted';
          break;

        case 2:
          qualificationColorClass = 'qualification-color-not-contacted';
          break;

        case 3:
          qualificationColorClass = 'qualification-color-contacted';
          break;

        case 4:
          qualificationColorClass = 'qualification-color-interviewing';
          break;

        case 5:
          qualificationColorClass = 'qualification-color-submitted';
          break;

        case 6:
          qualificationColorClass = 'qualification-color-offered-employment';
          break;
        case 7:
          qualificationColorClass = 'qualification-color-employed';
          break;
        case 8:
          qualificationColorClass = 'qualification-color-no-longer-interested';
          break;
        case 9:
          qualificationColorClass = 'qualification-color-not-in-consideration';
          break;

        case 10:
          qualificationColorClass = 'qualification-color-qualifying';
          break;

        case 11:
          qualificationColorClass = 'qualification-color-responded';
          break;

        default:
          qualificationColorClass = 'color-default';
          break;
      }

      return qualificationColorClass;
    },
    getQualificationColorClassByTitle(qualificationTitle) {
      /*   public const QUALIFICATION_NOT_CONTACTED = 1;
    public const QUALIFICATION_CONTACTED = 2;
    public const QUALIFICATION_INTERVIEWING = 3;
    public const QUALIFICATION_SUBMITED = 4;
    public const QUALIFICATION_NO_LONGER_INTERESTED = 5;
    public const QUALIFICATION_NOT_IN_CONSIDERATION = 6; */

      let qualificationColorClass;

      switch (qualificationTitle) {
        case 'Not submitted':
          qualificationColorClass = 'qualification-color-not-submitted';
          break;

        case 'Not contacted':
          qualificationColorClass = 'qualification-color-not-contacted';
          break;

        case 'Contacted':
          qualificationColorClass = 'qualification-color-contacted';
          break;

        case 'Interviewing':
          qualificationColorClass = 'qualification-color-interviewing';
          break;

        case 'Submitted':
          qualificationColorClass = 'qualification-color-submitted';
          break;

        case 'Offered employment':
          qualificationColorClass = 'qualification-color-offered-employment';
          break;

        case 'Employed':
          qualificationColorClass = 'qualification-color-employed';
          break;

        case 'No longer interested':
          qualificationColorClass = 'qualification-color-no-longer-interested';
          break;

        case 'Not in consideration':
          qualificationColorClass = 'qualification-color-not-in-consideration';
          break;

        case 'Qualifying':
          qualificationColorClass = 'qualification-color-qualifying';
          break;

        case 'Responded':
          qualificationColorClass = 'qualification-color-responded';
          break;

        default:
          qualificationColorClass = 'color-default';
          break;
      }

      return qualificationColorClass;
    },
  },
};
